import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { isNullOrUndefined } from "utils/validations";
import {
  enumsChangeUserType,
  enumsFormStatus,
  enumsInitialMaxUsersConfig,
  enumsTask,
  enumsTaskPriority,
  enumsTaskType,
  enumsTypeResponsible,
  enumsTypeStatusUser,
  enumsTypeUser,
  HttpStatus,
} from "utils/enums";
import {
  initialPaginationStandarThousandItems,
  initialPaginationStandarTwentyItems,
} from "utils/initialPaginationsConfig";
import {
  alertErrorUserTask,
  alertTaskCompleted,
  alertTaskDisrupted,
  handleAlertDeleteConfigForm,
  showAlertSaveReassign,
  showAlertServiceError,
  showAlertSuccessSenderSelect,
  showCreateWorkflowConfigSuccess,
  showTaskEmptyFilterTask,
  showTasksEmpty,
} from "utils/alerts";
import { processSortAndSetUsers, sortStepsList } from "utils/sortHelpers";
import { useTranslation } from "react-i18next";
import useWorkFlow from "hooks/useWorkFlow";
import useUser from "hooks/useUser";
import useForms from "hooks/useForm";
import swal from "sweetalert";

const WorkflowContext = React.createContext(undefined);

export function WorkflowContextProvider({ children }) {
  const { t } = useTranslation();
  const [hasUnauthorizedError, setHasUnauthorizedError] = useState(false);
  const [isLoadingReassingTask, setIsLoadingReassingTask] = useState(false);
  const [isLoadingSteps, setIsLoadingSteps] = useState(false);
  const [showModalReassignTask, setShowModalReassignTask] = useState(false);
  const [showModalAccomplishProcess, setShowModalAccomplishProcess] = useState(false);
  const [commentAccomplishTask, setCommentAccomplishTask] = useState("");
  const [reassignTaskUsers, setReassignTaskUsers] = useState({
    users_uuid: [],
  });
  const [reassignProcessUsers, setReassignProcessUsers] = useState({
    reassign_user_uuid: "",
  });
  const [reassignProcessBatch, setReassignProcessBatch] = useState({
    reason: "",
    reassign_user_uuid: "",
    tasks: [],
  });
  const [reassignManagementProcessData, setReassignManagementProcessData] = useState({
    reason: "",
    property_user_uuid: "",
    reassign_user_uuid: "",
    tasks: [],
  });
  const [accomplishProcessManagement, setAccomplishProcessManagement] = useState({
    reason: "",
    property_user_uuid: null,
    tasks: [],
    select_step: null,
    select_responsible: null,
  });
  const [disabledButtonBatchProcess, setDisabledButtonBatchProcess] = useState(true);
  const [showReassingn, setShowReassingn] = useState(false);
  const [taskDetail, setTaskDetail] = useState({});
  const [activateReassingBatchOption, setActivateReassingBatchOption] = useState("");
  const [isLoadingGeneralusers, setIsLoadingGeneralusers] = useState(false);
  const [generalUsersDinamic, setGeneralUsersDinamic] = useState([]);
  const [activateInterruptBatchOption, setActivateInterruptBatchOption] = useState(false);
  const [taskSelectedByBatch, setTaskSelectedByBatch] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [formIdInfo, setFormIdInfo] = useState("");
  const [listWorkflowSteps, setListWorkflowSteps] = useState([]);
  const [nameProcess, setNameProcess] = useState();
  const [forms, setForms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFilterTasks, setIsLoadingFilterTasks] = useState(false);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [pagination, setPagination] = useState(initialPaginationStandarTwentyItems);
  const [paginationForms] = useState({
    page: 1,
    perPage: 100,
    search: "",
    status: enumsFormStatus.FORMS_STATUS_INACTIVE,
    actions: 0,
  });
  const [showOptions, setShowOptions] = useState("1");
  const [reassign, setReassign] = useState({
    allow_reassign: false,
    allow_interrupt_process: false,
    allow_return_to_step: false,
    electronic_signature: false,
    place_profile_signature: false,
    move_file_to_trash: false,
    virtual_token_signature: false,
  });
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [listReal, setListReal] = useState([]);
  const [loader, setLoader] = useState(false);
  const [responsibleUser, setResponsibleUser] = useState("");
  const [responsibleList, setResponsibleList] = useState([]);
  const [listNameGroups, setListNamesGroups] = useState([]);
  const [nameGroup, setNameGroup] = useState("");
  const [typeResponsibleUser, setTypeResponsibleUser] = useState(null);
  const [typeResponsibleGroup, setTypeResponsibleGroup] = useState(false);
  const [userStep, setUserStep] = useState([]);
  const [idWorkGroup, setIdWorkGroup] = useState();
  const [usersDinamic, setUsersDinamic] = useState([]);
  const [usersDinamicEdit, setUsersDinamicEdit] = useState([]);
  const [usersDinamicProcess, setUsersDinamicProcess] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [perPage] = useState(500);
  const [activeStatus] = useState(enumsFormStatus.FORMS_STATUS_ACTIVE);
  const [responsibleOption, setResponsibleOption] = useState({
    responsible: "",
  });
  const [viewAddFields, setViewAddFields] = useState(false);
  const [fillingOutForm, setFillingOutForm] = useState(false);
  const [dataFormSelected, setDataFormSelected] = useState("");
  const { selectedOption } = useState([]);
  const [isEditWorkGroupStep, setIsEditWorkGroupStep] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalGroup, setShowModalGroup] = useState(false);
  const [stepUuid, setStepUuid] = useState("");
  const [workflowid, setWorkflowid] = useState("");
  const [addMember, setAddMember] = useState({
    user_uuid: "",
    step_uuid: "",
    workflow_uuid: "",
  });
  const [addMembersList, setAddMembersList] = useState({
    user_uuid_list: [],
    step_uuid: "",
    workflow_uuid: "",
  });
  const [isCompletedTask, setIsCompletedTask] = useState(false);
  const [isError, setIsError] = useState(false);
  const [process, setProcess] = useState({});
  const [status, setStatus] = useState("");
  const [isProcess] = useState(true);
  const [isProcessTask, setIsProcessTask] = useState(false);
  const [acordeon, setAcordeon] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [taskUuid, setTaskUuid] = useState("");
  const [tasks, setTasks] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  const [isLoadingFilter, setIsLoadingFilter] = useState(false);
  const [selectFormLabel, setSelectFormLabel] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [task, setTask] = useState({});
  const [type, setType] = useState("");
  const [priority, setPriority] = useState("");
  const [comply, setComply] = useState({});
  const [commentCreate, setCommentCreate] = useState({
    process_task_uuid: "",
    comment: "",
  });
  const [showInterruptProcess, setShowInterruptProcess] = useState(false);
  const [showDeleteFilesProcess, setShowDeleteFilesProcess] = useState(false);
  const [showSignFilesProcess, setShowSignFilesProcess] = useState(false);
  const [showSignFilesPKIProcess, setShowSignFilesPKIProcess] = useState(false);
  const [showSignFilesRubric, setShowSignFilesRubric] = useState(false);
  const [showPreviewFile, setShowPreviewFile] = useState(false);
  const [isLoadingViewFileRubric, setIsLoadingViewFileRubric] = useState(false);
  const [fileRubricLoaded, setFileRubricLoaded] = useState(null);
  const [fileUuidToRubric, setFileUuidToRubric] = useState("");
  const [formName, setFormName] = useState("");
  const [formFilingName, setFormFilingName] = useState("");
  const [formExternalName, setFormExternalName] = useState("");
  const [forcedUpdateFormName, setForcedUpdateFormName] = useState(false);
  const [showModalReasign, setShowModalReasign] = useState(false);
  const [nextStepId, setNextStepId] = useState("");
  const [workflowId, setWorkflowId] = useState("");
  const [files, setFiles] = useState([]);
  const [comments, setComments] = useState([]);
  const [complyProcessGateWay, setComplyProcessGateWay] = useState({
    status: 2,
    next_user_uuid: "",
    next_step_uuid: "",
  });
  const [selectLabelSequenceFlow, setSelectLabelSequenceFlow] = useState(false);
  const [requiredfilledform, setRequiredfilledform] = useState(false);
  const [fullfilCompleted, setFullfilCompleted] = useState(false);
  const [showFormFillingProcess, setShowFormsFillingProcess] = useState(false);
  const [showExternalFormFillingProcess, setShowExternalFormsFillingProcess] = useState(false);
  const [processId, setProcessId] = useState(null);
  const [editConfigStepsTab3FormData, setEditConfigStepsTab3FormData] = useState(false);
  const [showExternalFormEdit, setShowExternalFormEdit] = useState(false);
  const [selectFormId, setSelectFormId] = useState("");
  const [firstCheck, setFirstCheck] = useState(false);
  const [isLoadingComplyProcessBatch, setIsLoadingComplyProcessBatch] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState("");
  const [formsDinamic, setFormsDinamic] = useState([]);
  const [workflowDinamic, setWorkflowDinamic] = useState([]);
  const [stepsDinamic, setStepsDinamic] = useState([]);
  const [selectFormIdContext, setSelectFormIdContext] = useState(false);
  const [selectWorkflowId, setSelectWorkflowId] = useState("");
  const [selectWorkflowLabel, setSelectWorkflowLabel] = useState("");
  const [selectedOptionsWorkflow, setSelectedOptionsWorkflow] = useState("");
  const [selectStepId, setSelelectStepId] = useState("");
  const [selecStepLabel, setSelectStepLabel] = useState("");
  const [selectedOptionsStep, setSelectedOptionsStep] = useState("");
  const [complyTaskRequest, setComplyTaskRequest] = useState(false);
  const [processUuid, setProcessUuid] = useState("");
  const [isVisibleButtonProcessBatch, setIsVisibleButtonProccessBatch] = useState(true);
  const [taskProcessId, setTaskProcessId] = useState("");
  const [openWizardProcess, setOpenWizardProcess] = useState(false);
  const [isOpenModalPortal, setIsOpenModalPortal] = useState(false);
  const [numberOfMembers] = useState(enumsInitialMaxUsersConfig);
  const [commentCreateProcessBatch, setCommentCreateProcessBatch] = useState({
    comment: "",
  });
  const [configProcessBatch, setConfigProcessBatch] = useState({
    tasId: "",
    recordId: "",
    formId: "",
    fileByTrd: "",
    parentId: "",
    file: [],
    uploadForm: {},
  });
  const [nextStepWizzard, setNextStepWizzard] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [checkedOmitedUploadFile, setCheckedUploadFile] = useState(false);
  const [isNextStep, setIsNextStep] = useState(false);
  const [processTaskBatch, setProcessTaskBatch] = useState(false);
  const [isLoadingResponsilblesList, setIsLoadingResponsilblesList] = useState(false);
  const [structureQueryByFilterTask, setStructureQueryByFilterTask] = useState(
    {
    form_uuid: null,
    search_filter: [],
    workflow_uuid: null,
    step_uuid: null,
  });
  const [querySearchForm, setQuerySearchForm] = useState("");
  const [copiedSelectedOptionWorkflow, setCopiedSelectedOptionWorkflow] = useState({});
  const [copiedSelectedOptionStep, setCopiedSelectedOptionStep] = useState({});
  const [copiedSelectedOption, setCopiedSelectedOption] = useState({});
  const [uploadFormWorkflow, setUploadFormWorkflow] = useState({
    files: [],
  });
  const [uploadFormStartDate, setUploadFormStartDate] = useState("");
  const [checkedFilingForm, setCheckedFilingForm] = useState(false);
  const [isAdvancedFilterTask, setIsAdvancedFilterTask] = useState(false);
  const [formExternalList, setFormExternalList] = useState([]);
  const [orderHeaderBy, setOrderHeaderBy] = useState();
  const [orderHeaderType, setOrderHeaderType] = useState();
  const [filterDone, setFilterDone] = useState(false);

  const [showModalReturnToStep, setShowModalReturnToStep] = useState(false);
  const { selectedOptionStepToReturn } = useState([]);
  const [isErrorReturnToStep, setIsErrorReturnToStep] = useState(false);
  const [returnToStepProcessData, setReturnToStepProcessData] = useState({
    reason: "",
    return_process_task_uuid: "",
  });
  const [isLoadingStepsToReturn, setIsLoadingStepsToReturn] = useState(false);
  const [stepsToReturnList, setStepsToReturnList] = useState([]);
  const [isLoadingReturningTask, setIsLoadingReturningTask] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [usersForNotificaction, setUsersForNotificaction] = useState([]);
  const [expirationDateData, setExpirationDateData] = useState({
    date_execute: 1,
    unit_of_measure: 2,
  });
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [dropdownFilesOpen, setDropdownFilesOpen] = useState(false);
  const [templatesConfigByStep, setTemplatesConfigByStep] = useState([]);
  const [templatesSelectedByStep, setTemplatesSelectedByStep] = useState([]);
  const [templatesSelectedDetail, setTemplatesSelectedDetail] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [isLoadingSaveFileTemplate, setIsLoadingSaveFileTemplate] = useState(false);
  const {
    getWorkFlowSteps,
    getListResponsibles,
    addResponsibleStep,
    addResponsibleSenderSelects,
    getProcessByUuid,
    configureActions,
    getUserForReassing,
    getTasks,
    getTasksByUuid,
    fulfillTask,
    getListUserByProcess,
    getFilesByProcess,
    getFilesByTask,
    deleteConfigurationDataFormInStep,
    verifyProcessBatch,
    advancedFilterTasks,
    getStepsToReturn,
    getCommentsTaskByUuid,
    getCommentsProcessByUuid,
  } = useWorkFlow();

  const { getForms, getTemplateByForm } = useForms();
  const { getUsers, getWorkGroupsByStatus } = useUser();

  /**
   * Handles the click event to show a modal dialog by setting 'showModal' to true.
   * @returns {void} - This function does not return a value.
   */
  const handleOnClick = () => {
    setShowModal(true);
  };

  /**
   * Handles the click event to show a workgroup edit modal and sets 'isEditWorkGroupStep' to true.
   * @returns {void} - This function does not return a value.
   */
  const handleOnClickEditWorkGroup = () => {
    setShowModalGroup(true);
    setIsEditWorkGroupStep(true);
  };

  /**
   * Handles the close event for a modal by setting 'showModal' to false.
   * @returns {void} - This function does not return a value.
   */
  const handleOnClose = () => {
    setShowModal(false);
  };

  /**
   * Verifies the process batch asynchronously.
   * Sets loading state, prepares selected tasks, sends request, handles response, and catches errors.
   * @param {Array} selectedFields - Array of selected fields.
   * @param {function} setIsLoadingFilterTasks - State setter function to update loading state for filter tasks.
   * @param {function} verifyProcessBatch - Function to verify the process batch.
   * @param {function} setIsVisibleButtonProccessBatch - State setter function to update visibility of the process batch button.
   * @param {function} showAlertServiceError - Function to show alert for service error.
   * @param {JSX.Element} i18n - JSX element for internationalization.
   * @param {function} isNullOrUndefined - Function to check if a value is null or undefined.
   * @returns {Promise<void>} - Promise that resolves once the verification process is complete.
   */
  const funcVerifyProcessBatch = async () => {
    setIsLoadingFilterTasks(true);
    const selectedTasksToVerify = {
      tasks: selectedFields,
    };
    verifyProcessBatch(selectedTasksToVerify)
      .then((response) => {
        if (response.status === 201) {
          const responseData = response.data.data;
          setActivateReassingBatchOption(responseData.actions.allow_reassign);
          setActivateInterruptBatchOption(responseData.actions.allow_interrupt_process);
          setIsVisibleButtonProccessBatch(false);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }

        const swalMessageConfig = {
          title: t("modal.DoneError.header"),
          icon: "error",
          button: t("modal.Done.footerButton"),
          dangerMode: true,
          text: `${t("taskBatchProcess.alert.error")}: \n`,
        };
        if (isNullOrUndefined(error.response) === false) {
          const errors = error.response.data.data;
          errors.forEach((error) => {
            if (error.code === "50098") {
              swalMessageConfig.text += "*" + t("50098") + "\n";
            }
            if (error.code === "50099") {
              swalMessageConfig.text += "*" + t("50099") + "\n";
            }
            if (error.code === "50100") {
              swalMessageConfig.text += "*" + t("50100") + "\n";
            }
            if (error.code === "50106") {
              swalMessageConfig.text += "*" + t("50106") + "\n";
            }
          });
          swal(swalMessageConfig);
        }
      })
      .finally(() => {
        setIsLoadingFilterTasks(false);
      });
  };

  /**
   * Handles the close event for a task-related modal. It clears errors, hides the modal, and resets 'reassignTaskUsers'.
   */
  const handleOnCloseTask = () => {
    setIsError(false);
    setShowModal(false);
    setReassignTaskUsers({
      ...reassignTaskUsers,
      users_uuid: [],
    });
  };

  /**
   * Handles the close event for a process-related modal. It hides the modal, clears errors, and resets 'commentCreate' and 'reassignProcessUsers'.
   */
  const handleOnCloseProcess = () => {
    setShowModal(false);
    setIsError(false);
    setCommentCreate({
      ...commentCreate,
      comment: "",
    });
    setReassignProcessUsers({
      ...reassignProcessUsers,
      reassign_user_uuid: "",
    });
  };

  /**
   * Handles the click event to toggle the accordion state between true and false.
   */
  const handleOnClickAcordeon = () => {
    if (acordeon === false) {
      setAcordeon(true);
    } else {
      setAcordeon(false);
    }
  };

  /**
   * Fetches tasks based on the current pagination settings. Sets loading state, retrieves tasks,
   * and updates the state with task data. Displays an alert if there are no tasks found.
   */
  const getTasksBySearch = useCallback(
    (taskType, orderType, orderBy) => {
      const { page, per_page } = pagination;
      setIsLoading(true);
      getTasks(page, per_page, taskType, orderType, orderBy)
        .then((response) => {
          if (isNullOrUndefined(response.data.data) === false) {
            const responseData = response.data.data;
            if (responseData.items.length === 0) {
              showTasksEmpty();
            }
            setTasks(responseData.items);
            setTotalCount(responseData.count);
            setTotalPages(responseData.pages);
          } else {
            showAlertServiceError();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [pagination]
  );

  /**
   * Fetches task details by its unique identifier (UUID). Sets loading state, retrieves task details,
   * and updates the state with task information including status, type, and priority.
   * @param {string} id - The unique identifier of the task.
   */
  const getTasksByFilter = useCallback(
    (searchFilterTaskByCriteria, orderType, orderBy) => {
      const { page, per_page } = pagination;
      setIsLoadingFilterTasks(true);
      advancedFilterTasks(page, per_page, searchFilterTaskByCriteria, orderType, orderBy)
        .then((response) => {
          if (isNullOrUndefined(response.data) === false) {
            const tasksByAdvancedFilters = response.data;
            if (tasksByAdvancedFilters.items.length === 0) {
              showTaskEmptyFilterTask();
            }
            setFilterDone(true);
            setTasks(tasksByAdvancedFilters.items);
            setIsFilter(true);
            setTotalCount(tasksByAdvancedFilters.count);
            setTotalPages(tasksByAdvancedFilters.pages);
          } else {
            showAlertServiceError();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        })
        .finally(() => {
          setIsLoadingFilterTasks(false);
        });
    },
    [pagination]
  );

  /**
   * Fetches task details by its unique identifier (UUID). Sets loading state, retrieves task details,
   * and updates the state with task information including status, type, and priority.
   * @param {string} id - The unique identifier of the task.
   */
  const getTasksById = useCallback((id) => {
    setIsLoading(true);
    getTasksByUuid(id)
      .then((response) => {
        const taskDetails = response.data.data;
        if (isNullOrUndefined(taskDetails) === false) {
          setFormIdInfo(taskDetails.form_uuid);
          setTaskDetail(taskDetails);
          setTaskUuid(taskDetails.uuid);
          setComply({ status: enumsTask.COMPLETED });

          if (taskDetails.status !== enumsTask.IN_PROGRESS) {
            alertTaskCompleted();
          }

          if (taskDetails.status === enumsTask.IN_PROGRESS) {
            setStatus(t("taskDetailStatus1"));
          } else if (taskDetails.status === enumsTask.COMPLETED) {
            setStatus(t("taskDetailStatus2"));
          } else {
            setStatus(t("taskDetailStatus3"));
          }

          if (taskDetails.type === enumsTaskType.FREE_TASK) {
            setType(t("taskDetailType1"));
          } else {
            t("taskDetailType2");
          }

          if (taskDetails.priority === enumsTaskPriority.HIGH) {
            setPriority(t("notifications.priority1"));
          } else if (taskDetails.priority === enumsTaskPriority.MID) {
            setPriority(t("notifications.priority2"));
          } else {
            setPriority(t("notifications.priority3"));
          }
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  /**
   * Fulfills a task using the 'fulfillTask' API call. It shows a success alert and redirects to the task box upon success.
   */
  function fulfillTasks() {
    fulfillTask(taskUuid, comply)
      .then((response) => {
        if (response.status === 201) {
          const showAlertTaskfuldill = () => {
            swal({
              title: t("modal.DoneError.header"),
              text: t("taskComply1"),
              icon: "success",
              button: t("modal.Done.footerButton"),
            }).then(() => {
              window.location = "/taskBox";
            });
          };
          showAlertTaskfuldill();
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  /**
   * Fetches process details by its unique identifier (UUID). Sets loading state, retrieves process details,
   * and updates the state with process information including form-related data, reassignment settings, and status.
   * @param {string} id - The unique identifier of the process.
   */
  const getProcessById = useCallback((id, management) => {
    setIsLoading(true);
    getProcessByUuid(id, management)
      .then((response) => {
        if (isNullOrUndefined(response) === false) {
          const processData = response.data.data;
          setProcess(processData);
          setWorkflowId(processData.workflow_uuid);
          setNextStepId(processData.next_step_uuid);
          setTaskProcessId(processData.uuid);
          setProcessUuid(processData.process_uuid);
          setFormIdInfo(processData.form_uuid);
          setTemplatesConfigByStep(processData.step_config.templates);
          setShowReassingn(processData.step_config.actions.allow_reassign);
          setShowInterruptProcess(processData.step_config.actions.allow_interrupt_process);
          setShowDeleteFilesProcess(processData.step_config.actions.move_file_to_trash);
          setShowSignFilesProcess(processData.step_config.actions.electronic_signature);
          setShowSignFilesPKIProcess(processData.step_config.actions.virtual_token_signature);
          setShowSignFilesRubric(processData.step_config.actions.place_profile_signature);
          if (processData.form_external_records !== null) {
            setFormExternalList(processData.form_external_records);
          }
          if (processData.status === enumsTask.COMPLETED) {
            alertTaskCompleted();
            setIsCompletedTask(true);
          }
          if (processData.status === enumsTask.INTERRUPTED) {
            alertTaskDisrupted();
            setIsCompletedTask(true);
          }
          if (processData.step_config.form_name !== null) {
            setFormFilingName(processData.step_config.form_name);
          }
          if (processData.step_config.form_name_external !== null) {
            setFormExternalName(processData.step_config.form_name_external);
          }
          if (processData.step_config.data_form_required !== null) {
            setRequiredfilledform(processData.step_config.data_form_required);
          }
          if (processData.step_config.data_form_completed !== null) {
            setFullfilCompleted(processData.step_config.data_form_completed);
          }
          if (processData.status === enumsTask.IN_PROGRESS) {
            setStatus(t("taskDetailStatus1"));
          } else if (processData.status === enumsTask.COMPLETED) {
            setStatus(t("taskDetailStatus2"));
          } else {
            setStatus(t("taskDetailStatus3"));
          }
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  /**
   * Fetches workflow steps for a specific workflow by its unique identifier (UUID).
   * Sets the 'listWorkflowSteps' state with the retrieved workflow steps.
   * @param {string} id - The unique identifier of the workflow.
   */
  const getWorkFlowBySearch = useCallback((id) => {
    setIsLoadingSteps(true);
    getWorkFlowSteps(id)
      .then((response) => {
        if (isNullOrUndefined(response) === false) {
          setListWorkflowSteps(response);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        if (error.response.data.code === "50043") {
          setTimeout(() => {
            window.location = "/workflow/list";
          }, 4000);
        }
      })
      .finally(() => {
        setIsLoadingSteps(false);
        setIsLoading(false);
      });
  }, []);

  /**
   * Fetches information related to workflow responsibilities by its unique identifiers (workflowid and id).
   * This function sets various states to handle responsible data, including form information, user or group responsibilities,
   * reassignment settings, and user lists. It populates the 'usersDinamic' state with active users.
   * @param {string} workflowid - The unique identifier of the workflow.
   * @param {string} id - The unique identifier of the responsibility.
   */
  const getWorkFlowResponsibleById = useCallback(
    (workflowid, id) => {
      setLoader(true);
      setForcedUpdateFormName(false);
      getListResponsibles(workflowid, id)
        .then((response) => {
          if (isNullOrUndefined(response.data) === false) {
            const responsiblesInfoData = response.data;
            const actions = response.data.actions;
            const typeUsers = response.data.type_user_responsible;
            const userResponsibleList = response.data.user_responsible_list;
            const workGroupResponsible = response.data.work_group_responsible;
            const expirationDate = response.data.expiration_date_data;
            const templates = response.data.templates;
            const templatesForState = templates.map((opt) => ({
              value: opt.uuid,
            }));

            setTypeResponsibleUser(typeUsers);
            setStepUuid(id);
            setWorkflowid(workflowid);
            setTemplateList(templatesForState);

            if (expirationDate !== null) {
              setExpirationDateData((prevState) => ({
                ...prevState,
                date_execute: String(expirationDate.date_execute),
                unit_of_measure: String(expirationDate.unit_of_measure),
              }));
            }

            if (responsiblesInfoData.data_form !== null) {
              setFormName(responsiblesInfoData.data_form);
            }

            if (responsiblesInfoData.data_form_external !== null) {
              setFormExternalName(responsiblesInfoData.data_form_external);
            } else {
              setFormExternalName("");
            }

            if (isNullOrUndefined(userResponsibleList) === false) {
              if (userResponsibleList.length === 0) {
                setLoader(false);
              }
            }

            if (typeUsers === Number(enumsTypeUser.QUERY)) {
              setResponsibleUser(userResponsibleList[0]);
            } else {
              setResponsibleList(userResponsibleList);
            }

            if (typeUsers === Number(enumsTypeUser.ADMIN)) {
              setTypeResponsibleGroup(true);
              setIdWorkGroup(workGroupResponsible.work_group_uuid);
              setLoader(false);
            }

            const updateReassign = (key, value) => {
              let updatedValue = value;
              if (value === undefined) {
                updatedValue = false;
              }

              setReassign((prevState) => ({
                ...prevState,
                [key]: updatedValue,
              }));
            };

            updateReassign("allow_reassign", actions.allow_reassign);
            updateReassign("allow_interrupt_process", actions.allow_interrupt_process);
            updateReassign("allow_return_to_step", actions.allow_return_to_step);
            updateReassign("electronic_signature", actions.electronic_signature);
            updateReassign("virtual_token_signature", actions.virtual_token_signature);
            updateReassign("move_file_to_trash", actions.move_file_to_trash);
            updateReassign("place_profile_signature", actions.place_profile_signature);
          } else {
            showAlertServiceError();
          }

          const { page, per_page } = initialPaginationStandarThousandItems;
          let search = "";

          getUsers(page, per_page, search)
            .then((response) => {
              if (isNullOrUndefined(response.data) === false) {
                const usersList = response.data.items;
                usersList.forEach((user) => {
                  if (
                    user.status !== enumsTypeStatusUser.INACTIVE &&
                    user.status !== enumsTypeStatusUser.RETIRED
                  ) {
                    setUsersDinamic((prevState) => [
                      ...prevState,
                      {
                        value: user.uuid,
                        label: `${user.first_name} ${user.last_name} (${user.user_name})`,
                      },
                    ]);
                  }

                  if (
                    user.status !== enumsTypeStatusUser.INACTIVE &&
                    user.status !== enumsTypeStatusUser.RETIRED &&
                    user.user_type === enumsChangeUserType.ADMIN
                  ) {
                    setUsersForNotificaction((prevState) => [
                      ...prevState,
                      {
                        value: user.uuid,
                        label: `${user.first_name} ${user.last_name} (${user.user_name})`,
                      },
                    ]);
                  }
                });
              } else {
                showAlertServiceError();
              }
            })
            .catch((error) => {
              if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
                return;
              }
            });
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        });
    },
    [forcedUpdateFormName]
  );

  /**
   * Fetches a list of work groups based on their status and number of items per page.
   * Populates the 'listNamesGroups' state with unique work group names and UUIDs.
   */
  const getWorkGroupsBySearch = useCallback(() => {
    getWorkGroupsByStatus(perPage, activeStatus)
      .then((response) => {
        let listgroups = response.data.data.items;
        if (isNullOrUndefined(listgroups) === false) {
          let uniqueListNamesGroups = listgroups.reduce((uniqueList, { name, uuid }) => {
            if (!uniqueList.some((group) => group.value === uuid)) {
              uniqueList.push({
                value: uuid,
                label: name,
              });
            }
            return uniqueList;
          }, []);
          setListNamesGroups(uniqueListNamesGroups);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      });
  }, [getWorkGroupsByStatus, setListNamesGroups, activeStatus, perPage]);

  /**
   * This useEffect retrieves the name of a work group based on its UUID and sets it in the 'nameGroup' state.
   */
  useEffect(() => {
    const getNameOfWorkGroup = () => {
      const name = listNameGroups.find((group) => {
        if (group.value === idWorkGroup) {
          return group.label;
        }
        return null;
      });
      if (name !== undefined && name !== null) {
        setNameGroup(name.label);
      }
    };
    getNameOfWorkGroup();
  }, [listNameGroups, idWorkGroup]);

  /**
   * Fetches a list of users for reassignment by their associated task's unique identifier (UUID).
   * Sorts the users by name and populates the 'usersDinamic' state with active user data.
   * @param {string} id - The unique identifier of the associated task.
   */
  const getUsersBySearch = useCallback((id) => {
    setUsersDinamic([]);
    setIsLoadingUsers(true);

    getUserForReassing(id)
      .then((response) => {
        const listUsers = response.data.items;
        if (isNullOrUndefined(listUsers) === false) {
          processSortAndSetUsers(listUsers, setUsersDinamic);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response.data.code === "50016") {
          alertErrorUserTask();
        }
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingUsers(false);
      });
  }, []);

  /**
   * Fetches and processes a list of users associated with a specific process ID.
   * This function uses a callback to retrieve user data by process ID, sorts and filters
   * the list of users, and updates the dynamic user state. If the user list is null or undefined,
   * an error alert is shown. The loading state is managed during the asynchronous operation.
   * @param {string} id - The ID of the process to retrieve users for.
   */
  const getListUsersProcess = useCallback((id) => {
    setIsLoadingUsers(true);

    getListUserByProcess(id)
      .then((response) => {
        const listUsers = response.data.data.items;
        if (isNullOrUndefined(listUsers) === false) {
          processSortAndSetUsers(listUsers, setUsersDinamicProcess);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingUsers(false);
      });
  }, []);

  /**
   * Fetches general users data and updates state with active users for dynamic selection.
   * Retrieves users data and filters out inactive and retired users.
   * This function fetches users data based on pagination settings and updates
   * the dynamic list of general users with active users only.
   * @returns {void}
   */

  const getGeneralUsers = useCallback(() => {
    const { page, per_page } = initialPaginationStandarThousandItems;
    setIsLoadingGeneralusers(true);

    getUsers(page, per_page, "")
      .then((usersResponse) => {
        if (isNullOrUndefined(usersResponse.data.items) === false) {
          const usersList = usersResponse.data.items;
          processSortAndSetUsers(usersList, setGeneralUsersDinamic);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          setHasUnauthorizedError(true);
        }
      })
      .finally(() => {
        setIsLoadingGeneralusers(false);
      });
  }, []);

  /**
   * Retrieves files associated with a specific process by its ID.
   * This function makes an API call to fetch files related to the process
   * and updates the 'files' state with the response data.
   * If the response is null or undefined, an error alert is shown.
   * The loading state is managed during the operation.
   * @param {string} processId - The ID of the process to fetch files for.
   * @returns {void}
   */
  const getFilesProcessById = useCallback((processId) => {
    setIsLoadingFiles(true);
    getFilesByProcess(processId)
      .then((response) => {
        if (isNullOrUndefined(response) === false) {
          setFiles(response.data);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingFiles(false);
      });
  }, []);

  /**
   * Retrieves files associated with a specific task by its ID.
   * This function makes an API call to fetch files related to the task
   * and updates the 'files' state with the response data.
   * If the response is null or undefined, an error alert is shown.
   * The loading state is managed during the operation.
   * @param {string} taskId - The ID of the task to fetch files for.
   * @returns {void}
   */
  const getFilesTasksById = useCallback((taskId) => {
    setIsLoadingFiles(true);
    getFilesByTask(taskId)
      .then((response) => {
        if (isNullOrUndefined(response.data) === false) {
          setFiles(response.data);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingFiles(false);
      });
  }, []);

  /**
   * Fetches comments for a task by its unique identifier (UUID).
   * This function sets the loading state to true, makes an API call to fetch comments
   * related to the task, and updates the state with the retrieved comments data.
   * If the response is null or undefined, an error alert is shown.
   * The loading state is managed during the operation.
   * @param {string} id - The unique identifier of the task.
   * @returns {void}
   */
  const getCommentsTaskById = useCallback((id) => {
    setIsLoadingComments(true);
    getCommentsTaskByUuid(id)
      .then((response) => {
        if (isNullOrUndefined(response) === false) {
          setComments(response.data.data);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingComments(false);
      });
  }, []);

  /**
   * Fetches comments for a process by its unique identifier (UUID).
   * This function sets the loading state to true, makes an API call to fetch comments
   * related to the process, and updates the state with the retrieved comments data.
   * If the response is null or undefined, an error alert is shown.
   * The loading state is managed during the operation.
   * @param {string} id - The unique identifier of the process.
   * @returns {void}
   */
  const getCommentsProcessById = useCallback((id) => {
    setIsLoadingComments(true);
    getCommentsProcessByUuid(id)
      .then((response) => {
        if (isNullOrUndefined(response) === false) {
          setComments(response.data.data);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingComments(false);
      });
  }, []);

  /**
   * Fetches steps to return by process UUID and updates the state accordingly.
   * @param {string} processUuid The UUID of the process to fetch steps for.
   */
  const getStepsToReturnById = useCallback((processUuid) => {
    setIsLoadingStepsToReturn(true);
    getStepsToReturn(processUuid)
      .then((response) => {
        if (isNullOrUndefined(response.data) === false) {
          let stepsList = response.data;
          if (stepsList.length === 0) {
            return swal({
              title: t("modal.DoneError.header"),
              text: t("taskReturnNoStepsToReturn"),
              icon: "warning",
              button: t("modal.Done.footerButton"),
            }).then(() => {
              setDropdownOpen(false);
              setShowModalReturnToStep(false);
            });
          } else {
            setShowModalReturnToStep(true);
            sortStepsList(stepsList, setStepsToReturnList);
          }
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingStepsToReturn(false);
      });
  }, []);

  /**
   * Handles a change in the responsible option, updating the 'responsibleOption' state with the selected value.
   */
  const handleOnChangeOption = (e) => {
    setResponsibleOption({
      ...responsibleOption,
      responsible: e.target.value,
    });
  };

  /**
   * Handles the change event when users are selected. Updates the 'addMembersList' or 'addMember' state
   * based on the 'responsibleOption' and handles errors.
   * @param {object} selectedOption - The selected options (an array of objects).
   */
  const handleOnChangeUsers = (selectedOption) => {
    if (selectedOption.length === 0) {
      setIsError(true);
    } else {
      if (responsibleOption.responsible === enumsTypeResponsible.listOfResponsible) {
        setAddMembersList({
          ...addMembersList,
          user_uuid_list: selectedOption.map((user) => user.value),
          step_uuid: stepUuid,
          workflow_uuid: workflowid,
        });
        setIsError(false);
      } else {
        setAddMember({
          ...addMember,
          user_uuid: selectedOption.value,
          step_uuid: stepUuid,
          workflow_uuid: workflowid,
        });
        setIsError(false);
      }
    }
  };

  /**
   * Handles the change event when a tab element is clicked.
   * It updates the 'reassign' state based on the tab's value and checkbox status.
   * @param {object} evetChange - The event object.
   */
  const handleOnChangeTab = (evetChange) => {
    const { name, checked } = evetChange.target;
    setReassign({
      ...reassign,
      [name]: checked,
    });
  };

  /**
   * Handles the submission of a form for adding responsible users or sender selects.
   * - If responsibleOption is "1", it handles the addition of a responsible user.
   * - If responsibleOption is "2", it handles the addition of multiple responsible sender selects.
   * @param {object} evetChange - The event object.
   */
  const handleOnSubmit = (evetChange) => {
    if (responsibleOption.responsible === enumsTypeResponsible.singleResponsible) {
      if (addMember.user_uuid === "") {
        setIsError(true);
        setIsLoading(false);
        evetChange.preventDefault();
        return;
      } else {
        setIsLoading(true);
        addResponsibleStep(addMember)
          .then((response) => {
            if (response.data.code === 5021) {
              showCreateWorkflowConfigSuccess();
            } else {
              showAlertServiceError();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
              return;
            }
          })
          .finally(() => {
            setIsLoading(false);
            setShowModal(false);
          });
      }
    } else if (responsibleOption.responsible === enumsTypeResponsible.listOfResponsible) {
      if (
        addMembersList.user_uuid_list.length === 0 ||
        addMembersList.user_uuid_list.length === numberOfMembers.minimumMembers - 1
      ) {
        setIsError(true);
        setIsLoading(false);
        evetChange.preventDefault();
        return;
      }
      if (addMembersList.user_uuid_list.length > numberOfMembers.maximumMembers) {
        setIsLoading(false);
        evetChange.preventDefault();
        return;
      }
      if (isError) {
        evetChange.preventDefault();
        return;
      } else {
        setIsError(false);
        setIsLoading(true);
        addResponsibleSenderSelects(addMembersList)
          .then((response) => {
            if (response.status === 201) {
              showAlertSuccessSenderSelect();
            } else {
              showAlertServiceError();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
              return;
            }
          })
          .finally(() => {
            setIsLoading(false);
            setShowModal(false);
          });
      }
    }
  };

  /**
   * Handles the submission of the actions configuration form. If there are no errors,
   * it triggers the configuration of actions for a workflow step.
   * @param {object} _ - The event object.
   * @param {array} errors - The array of errors.
   */
  const handleOnSubmitActions = (_, errors) => {
    if (errors.length === 0) {
      setIsLoading(true);
      configureActions(workflowid, stepUuid, reassign)
        .then((response) => {
          if (response.status === 202) {
            showAlertSaveReassign();
          } else {
            showAlertServiceError();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  /**
   * Handles the submission of the task compliance form. Displays a confirmation dialog to fulfill the task.
   * @param {object} evetChange - The event object.
   */
  const handleOnSubmitComplytask = (evetChange) => {
    evetChange.preventDefault();
    const showAlertShure = () => {
      swal({
        title: t("modal.DoneError.header"),
        text: t("taskComply"),
        icon: "warning",
        buttons: [t("createusers.createButton2"), t("modal.Done.footerButton")],
      }).then((willClose) => {
        if (willClose) {
          fulfillTasks(taskUuid, comply);
        } else {
          evetChange.preventDefault();
          setIsLoading(false);
        }
      });
    };
    showAlertShure();
  };

  /**
   * Retrieves active forms based on pagination configuration and updates the state accordingly.
   * @param {object} paginationForms - Object containing pagination parameters.
   * @param {number} paginationForms.page - The current page number.
   * @param {number} paginationForms.perPage - The number of items per page.
   * @param {string} paginationForms.search - The search query string.
   * @param {string} paginationForms.status - The status of the forms to be retrieved.
   * @param {string[]} paginationForms.actions - An array of actions associated with the forms.
   * @param {function} getForms - Function to retrieve forms based on provided parameters.
   * @param {function} setForms - State setter function for updating the list of forms.
   * @param {function} setIsLoading - State setter function to indicate loading status.
   * @returns {void}
   */
  const getActiveForms = useCallback(() => {
    const { page, perPage, search, status, actions } = paginationForms;
    setIsLoading(true);
    getForms(page, perPage, search, status, actions)
      .then((response) => {
        if (isNullOrUndefined(response.data) === false) {
          setForms(response.data.items);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [getForms]);

  /**
   * Handles the deletion of configuration data form in a workflow step.
   * @param {Event} eventDeleteFormInStep - The event triggered by form deletion.
   * @param {number} stepId - The ID of the workflow step.
   * @param {number} workflowId - The ID of the workflow.
   * @returns {void}
   */
  const handleDeleteConfigurationDataFormInStep = (eventDeleteFormInStep, stepId) => {
    swal({
      title: t("modal.DoneError.header"),
      text: t("WorkFlowEdit.delete"),
      icon: "warning",
      buttons: [t("createusers.createButton2"), t("modal.Done.footerButton")],
    }).then((willDeleteWorkFlowConfigForm) => {
      if (willDeleteWorkFlowConfigForm) {
        deleteConfigurationDataFormInStep(workflowid, stepId).then(() => {
          setEditConfigStepsTab3FormData(false);
          setFormExternalName("");
          handleAlertDeleteConfigForm();
        });
      } else {
        eventDeleteFormInStep.preventDefault();
      }
    });
  };

  /**
   * Opens or closes the wizard process batch based on the current state.
   * @returns {void}
   */
  const openWizardProcessBatch = () => {
    setOpenWizardProcess((prevState) => !prevState);
  };

  /**
   * Fetches and processes templates for a specified form using pagination.
   * This function retrieves templates associated with a specific form ID, utilizing pagination
   * to manage the number of templates fetched per request. It filters the templates to include
   * only those with an active status, sorts them by name, and maps them into a format suitable
   * for selection. If the response data is null or undefined, an error alert is displayed.
   * Unauthorized errors are handled by returning early. The function manages the loading state
   * throughout the fetch process.
   * @param {Object} pagination - Contains pagination details.
   * @param {number} pagination.page - The current page number for fetching templates.
   * @param {number} pagination.per_page - The number of templates to fetch per page.
   * @returns {void}
   *
   */
  const getTemplates = useCallback((formId) => {
    const { page, per_page } = initialPaginationStandarThousandItems;
    setIsLoadingTemplates(true);
    getTemplateByForm(formId, page, per_page)
      .then((response) => {
        if (isNullOrUndefined(response.data.items) === false) {
          const listTemplates = response.data.items;
          setAllTemplates(listTemplates);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingTemplates(false);
      });
  }, []);

  return (
    <WorkflowContext.Provider
      value={{
        listWorkflowSteps,
        setListWorkflowSteps,
        nameProcess,
        setNameProcess,
        isLoading,
        setIsLoading,
        pagination,
        setPagination,
        getWorkFlowBySearch,
        getWorkFlowResponsibleById,
        loader,
        setLoader,
        responsibleUser,
        setResponsibleUser,
        responsibleList,
        setResponsibleList,
        typeResponsibleUser,
        setTypeResponsibleUser,
        userStep,
        setUserStep,
        usersDinamic,
        setUsersDinamic,
        responsibleOption,
        setResponsibleOption,
        handleOnChangeOption,
        showOptions,
        setShowOptions,
        selectedOption,
        showModal,
        setShowModal,
        addMember,
        setAddMember,
        addMembersList,
        setAddMembersList,
        handleOnClick,
        handleOnClose,
        isError,
        setIsError,
        handleOnChangeUsers,
        handleOnSubmit,
        getProcessById,
        process,
        status,
        isProcess,
        isProcessTask,
        setIsProcessTask,
        acordeon,
        handleOnClickAcordeon,
        showDetail,
        setShowDetail,
        reassign,
        setReassign,
        handleOnChangeTab,
        handleOnSubmitActions,
        getUsersBySearch,
        getWorkGroupsBySearch,
        getTasksBySearch,
        getTasksById,
        setTask,
        tasks,
        setTasks,
        totalPages,
        totalCount,
        task,
        setTaskUuid,
        type,
        priority,
        comply,
        handleOnSubmitComplytask,
        handleOnCloseTask,
        handleOnCloseProcess,
        getListUsersProcess,
        usersDinamicProcess,
        commentCreate,
        setCommentCreate,
        usersDinamicEdit,
        setUsersDinamicEdit,
        listReal,
        setListReal,
        typeResponsibleGroup,
        listNameGroups,
        setListNamesGroups,
        nameGroup,
        handleOnClickEditWorkGroup,
        isEditWorkGroupStep,
        idWorkGroup,
        showModalGroup,
        setShowModalGroup,
        getActiveForms,
        forms,
        dataFormSelected,
        setDataFormSelected,
        setViewAddFields,
        viewAddFields,
        fillingOutForm,
        setFillingOutForm,
        formName,
        formIdInfo,
        setFormIdInfo,
        nextStepId,
        setNextStepId,
        workflowId,
        getFilesProcessById,
        getFilesTasksById,
        getCommentsTaskById,
        getCommentsProcessById,
        showModalReasign,
        setShowModalReasign,
        files,
        setFiles,
        isLoadingFiles,
        setIsLoadingFiles,
        comments,
        setComments,
        isLoadingComments,
        complyProcessGateWay,
        setComplyProcessGateWay,
        selectLabelSequenceFlow,
        setSelectLabelSequenceFlow,
        showInterruptProcess,
        showFormFillingProcess,
        setShowFormsFillingProcess,
        showExternalFormFillingProcess,
        setShowExternalFormsFillingProcess,
        processId,
        setProcessId,
        editConfigStepsTab3FormData,
        setEditConfigStepsTab3FormData,
        setForcedUpdateFormName,
        setFormName,
        formExternalName,
        setFormExternalName,
        requiredfilledform,
        setRequiredfilledform,
        fullfilCompleted,
        setFullfilCompleted,
        handleDeleteConfigurationDataFormInStep,
        handleAlertDeleteConfigForm,
        showExternalFormEdit,
        setShowExternalFormEdit,
        isLoadingResponsilblesList,
        setIsLoadingResponsilblesList,
        isCompletedTask,
        setIsCompletedTask,
        isFilter,
        setIsFilter,
        openModalFilter,
        setOpenModalFilter,
        isLoadingFilter,
        setIsLoadingFilter,
        getTasksByFilter,
        selectFormLabel,
        setSelectFormLabel,
        selectFormId,
        setSelectFormId,
        firstCheck,
        setFirstCheck,
        selectedOptions,
        setSelectedOptions,
        selectWorkflowId,
        setSelectWorkflowId,
        selectWorkflowLabel,
        setSelectWorkflowLabel,
        selectedOptionsWorkflow,
        setSelectedOptionsWorkflow,
        selectStepId,
        setSelelectStepId,
        selecStepLabel,
        setSelectStepLabel,
        selectedOptionsStep,
        setSelectedOptionsStep,
        selectFormIdContext,
        setSelectFormIdContext,
        formsDinamic,
        setFormsDinamic,
        workflowDinamic,
        setWorkflowDinamic,
        stepsDinamic,
        setStepsDinamic,
        selectedFields,
        setSelectedFields,
        isVisibleButtonProcessBatch,
        setIsVisibleButtonProccessBatch,
        openWizardProcess,
        setOpenWizardProcess,
        openWizardProcessBatch,
        disabledButtonBatchProcess,
        setDisabledButtonBatchProcess,
        complyTaskRequest,
        setComplyTaskRequest,
        processUuid,
        taskProcessId,
        isOpenModalPortal,
        setIsOpenModalPortal,
        commentCreateProcessBatch,
        setCommentCreateProcessBatch,
        configProcessBatch,
        setConfigProcessBatch,
        nextStepWizzard,
        setNextStepWizzard,
        currentStep,
        setCurrentStep,
        isLoadingComplyProcessBatch,
        setIsLoadingComplyProcessBatch,
        checkedOmitedUploadFile,
        setCheckedUploadFile,
        showPreviousButton,
        setShowPreviousButton,
        isNextStep,
        setIsNextStep,
        processTaskBatch,
        setProcessTaskBatch,
        structureQueryByFilterTask,
        setStructureQueryByFilterTask,
        isLoadingFilterTasks,
        setIsLoadingFilterTasks,
        querySearchForm,
        setQuerySearchForm,
        copiedSelectedOptionWorkflow,
        setCopiedSelectedOptionWorkflow,
        copiedSelectedOptionStep,
        setCopiedSelectedOptionStep,
        copiedSelectedOption,
        setCopiedSelectedOption,
        funcVerifyProcessBatch,
        uploadFormWorkflow,
        setUploadFormWorkflow,
        uploadFormStartDate,
        setUploadFormStartDate,
        taskDetail,
        setTaskDetail,
        showReassingn,
        reassignTaskUsers,
        setReassignTaskUsers,
        reassignProcessUsers,
        setReassignProcessUsers,
        reassignProcessBatch,
        setReassignProcessBatch,
        isLoadingReassingTask,
        setIsLoadingReassingTask,
        showModalReassignTask,
        setShowModalReassignTask,
        activateReassingBatchOption,
        activateInterruptBatchOption,
        taskSelectedByBatch,
        setTaskSelectedByBatch,
        formFilingName,
        checkedFilingForm,
        setCheckedFilingForm,
        isAdvancedFilterTask,
        setIsAdvancedFilterTask,
        formExternalList,
        orderHeaderBy,
        setOrderHeaderBy,
        orderHeaderType,
        setOrderHeaderType,
        filterDone,
        showModalReturnToStep,
        setShowModalReturnToStep,
        selectedOptionStepToReturn,
        isErrorReturnToStep,
        setIsErrorReturnToStep,
        returnToStepProcessData,
        setReturnToStepProcessData,
        getStepsToReturnById,
        isLoadingStepsToReturn,
        stepsToReturnList,
        setStepsToReturnList,
        isLoadingReturningTask,
        setIsLoadingReturningTask,
        dropdownOpen,
        setDropdownOpen,
        isLoadingSteps,
        isLoadingGeneralusers,
        isLoadingUsers,
        generalUsersDinamic,
        setGeneralUsersDinamic,
        getGeneralUsers,
        reassignManagementProcessData,
        setReassignManagementProcessData,
        showDeleteFilesProcess,
        showSignFilesProcess,
        showSignFilesPKIProcess,
        usersForNotificaction,
        expirationDateData,
        setExpirationDateData,
        hasUnauthorizedError,
        showModalAccomplishProcess,
        setShowModalAccomplishProcess,
        commentAccomplishTask,
        setCommentAccomplishTask,
        accomplishProcessManagement,
        setAccomplishProcessManagement,
        templateList,
        setTemplateList,
        isLoadingTemplates,
        getTemplates,
        dropdownFilesOpen,
        setDropdownFilesOpen,
        templatesConfigByStep,
        templatesSelectedByStep,
        setTemplatesSelectedByStep,
        templatesSelectedDetail,
        setTemplatesSelectedDetail,
        allTemplates,
        setAllTemplates,
        isLoadingSaveFileTemplate,
        setIsLoadingSaveFileTemplate,
        showSignFilesRubric,
        setShowSignFilesRubric,
        showPreviewFile,
        setShowPreviewFile,
        isLoadingViewFileRubric,
        setIsLoadingViewFileRubric,
        fileRubricLoaded,
        setFileRubricLoaded,
        fileUuidToRubric,
        setFileUuidToRubric,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
}

WorkflowContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export function useWorkflowContext() {
  const context = React.useContext(WorkflowContext);
  if (isNullOrUndefined(context) === true) {
    throw new Error("useWorkflowContext must be inside the WorkflowContext provider.");
  }
  return context;
}
